import React from 'react';

export const EventSkeleton = () => {
  return (
    <div className="event-skeleton">
      <div className="event-skeleton__header">
        <div className="event-skeleton__icon"></div>
        <div className="event-skeleton__title-section">
          <div className="event-skeleton__title"></div>
          <div className="event-skeleton__subtitle"></div>
        </div>
        <div className="event-skeleton__badge"></div>
      </div>
      <div className="event-skeleton__details">
        <div className="event-skeleton__line event-skeleton__line--full"></div>
        <div className="event-skeleton__line event-skeleton__line--partial"></div>
      </div>
    </div>
  );
};